import type { ReactNode } from 'react';
import { Box, Button, Group, Heading, Text } from '@optiaxiom/react';
import { IconCircleQuestion } from '@optiaxiom/icons';
import { Link as RouterLink } from 'react-router-dom';
import styles from './NotFoundPage.module.css';

interface NotFoundPageProps {
  title?: string;
  description?: ReactNode;
}

/**
 * In-shell not-found state. Used for the route catch-all (typo / stale deep link) and,
 * with tailored copy, e.g. a missing app (a deep-linked app id the backend 404s). Rendered
 * inside the app shell — unlike the route errorElement, which is reserved for crashes.
 */
export function NotFoundPage({
  title = 'Page not found',
  description = 'The page you’re looking for doesn’t exist or may have moved.',
}: NotFoundPageProps = {}) {
  return (
    <Group alignItems="center" flexDirection="column" className={styles.container}>
      <Box className={styles.iconTile} rounded="lg" bg="bg.secondary" color="fg.tertiary">
        <IconCircleQuestion size={30} />
      </Box>
      <Heading level="2" fontWeight="700" className={styles.title}>
        {title}
      </Heading>
      <Text color="fg.secondary" className={styles.body}>
        {description}
      </Text>
      <Button appearance="primary" size="lg" asChild>
        <RouterLink to="/apps">Back to apps</RouterLink>
      </Button>
    </Group>
  );
}
